
import { useParams, Link, Navigate } from "react-router-dom";
import { ProductDetails } from "@/components/ProductDetails";
import { getProductBySlug } from "@/data/products";
import { ArrowLeft } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

// Map of old product slugs to new ones for redirects
const productRedirectMap: Record<string, string> = {
  "rxt-8": "rxt-8d", // Add mapping for RXT-8D
  "rxt-10": "rxt-10d"
};

const Product = () => {
  const { slug } = useParams<{ slug: string }>();
  const { t } = useLanguage();
  
  // Check if we need to redirect
  if (slug && productRedirectMap[slug]) {
    return <Navigate to={`/product/${productRedirectMap[slug]}`} replace />;
  }
  
  const product = getProductBySlug(slug || "");

  if (!product) {
    return (
      <div className="container mx-auto px-4 py-16">
        <div className="text-center">
          <h1 className="text-2xl font-bold">{t('product.not.found')}</h1>
          <Link to="/" className="text-primary hover:underline">
            {t('return.to.home')}
          </Link>
        </div>
      </div>
    );
  }

  // Construct the back link URL including the speed parameter for AVOIP products
  const backLinkUrl = `/group/${product.groupId}${product.networkSpeed ? `?speed=${product.networkSpeed}` : ""}`;

  return (
    <div className="container mx-auto px-4 py-16">
      <Link
        to={backLinkUrl}
        className="mb-8 inline-flex items-center text-sm text-muted-foreground hover:text-foreground"
      >
        <ArrowLeft className="mr-2 h-4 w-4" />
        {t('back.to.product.group')}
      </Link>
      <ProductDetails product={product} />
    </div>
  );
};

export default Product;
